import { WbResponseError, WbHttpError } from 'errors';
import { InterWbLogger } from './InterWbLogger';
export class InterWbResponseHandler extends InterWbLogger {
    wbResponseHandler(event) {
        const { error, data, action } = event.detail;
        try {
            if (error && !data?.httpStatus) {
                throw new WbResponseError(error, action);
            }
            if (data?.httpStatus && data.httpStatus >= 400) {
                throw new WbHttpError(data.response, data.httpStatus, action);
            }
            let parsedData = {};
            if (data) {
                parsedData = typeof data === 'object' ? data : JSON.parse(data);
            }
            return parsedData;
        }
        catch (err) {
            if (err instanceof WbHttpError) {
                throw JSON.stringify({
                    action: err.action,
                    message: 'Erro na Api.',
                    httpStatus: err.httpStatus,
                    response: err.response,
                });
            }
            else if (err instanceof WbResponseError) {
                throw JSON.stringify({ action: err.action, message: err.message });
            }
            else {
                throw err;
            }
        }
    }
}
